import React from 'react'

import * as styles from './RequestDetailLayout.styles'

export const REQUEST_DETAIL_LAYOUT_TEST_ID = 'request-detail-layout'
export const REQUEST_DETAIL_ASIDE_TEST_ID = 'request-detail-aside'

export interface RequestDetailLayoutProps {
  children: React.ReactNode
  /** Context shown beside the request, e.g. its activity. Omit for a single-column page. */
  aside?: React.ReactNode
}

export const RequestDetailLayout = ({ children, aside }: RequestDetailLayoutProps): JSX.Element => (
  <styles.Layout data-testid={REQUEST_DETAIL_LAYOUT_TEST_ID}>
    <styles.Main>{children}</styles.Main>
    {!!aside && <styles.Aside data-testid={REQUEST_DETAIL_ASIDE_TEST_ID}>{aside}</styles.Aside>}
  </styles.Layout>
)

export default RequestDetailLayout
